module.exports = __webpack_public_path__ + "static/media/loop.b6d4e2f3.svg";